const CompanyDetails = ({ children = <div></div> }: { children: any }) => {
  return <div>{children}</div>;
};

export default CompanyDetails;
